// A cluster of three cattails: slender green stalks each topped with a brown
// seed-head. Ported 1:1 from age-of-mcp's classic cattail.ts, restoring its
// per-stalk loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (let i = 0; i < 3; i++) {
    const x = (i - 1) * 0.06;
    const len = 0.24 + i * 0.034;
    parts.push({
      geometry: new THREE.CylinderGeometry(0.006, 0.008, len, 4),
      color: "#3e7d36", position: [x, len / 2, 0],
    });
    parts.push({
      geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.066, 6),
      color: "#6e4a2c", position: [x, len + 0.026, 0],
    });
  }
  return parts;
}

export const cattail = defineModel({
  id: "cattail",
  batchId: "standard",
  name: "Cattail",
  tags: ["scenery","cattail","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly cattail.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: () => partsFor(),
  animations: [],
});
